import React, { useState } from "react";
import { ReactComponent as ArrowLeft } from "../assests/new-images/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../assests/new-images/arrow-right.svg";
import { Button, Divider } from "antd";

const PaginationComponent = ({ dataSource, pageSize, onPageChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(dataSource.length / pageSize);

  const handlePageChange = (page) => {
    const slicedData = dataSource.slice((page - 1) * pageSize, page * pageSize);
    setCurrentPage(page);
    onPageChange(page, slicedData);
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  let pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 || 
      i === totalPages || 
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pages.push(i);
    } else if (
      (i === currentPage - 1 - 1) || 
      (i === currentPage + 1 + 1)
    ) {
      pages.push("...");
    }
  }

  return (
    <div className="pagination-container d-flex justify-content-center">
      <div className="col-12 d-flex justify-content-between">
      <div align="left">
        <span
          className={`pagination-btn-prev ${
            currentPage === 1 ? "disabled" : ""
          }`}
          onClick={currentPage === 1 ? undefined : handlePrevious}
        >
          <ArrowLeft height={13} style={{marginTop:"-2px"}}/>
          Previous
        </span>
        </div>

        {/* <div align="center">
          {Array.from({ length: totalPages }, (_, index) => (
            <span
              key={index + 1}
              onClick={() => handlePageChange(index + 1)}
              className={`pagination-page ${
                currentPage === index + 1 ? "active" : ""
              } mx-1`}
            >
              {index + 1}
            </span>
          ))}
        </div> */}

        <div align="center">
      {pages?.map((option, index) => (
        <span
          key={index}
          onClick={() => handlePageChange(option)}
          className={`pagination-page ${
            currentPage === option ? "active" : ""
          } mx-1`}
        >
          {option}
        </span>
      ))}
    </div>
        <div align="right">
        <span
          className={`pagination-btn-next ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          onClick={currentPage === totalPages ? undefined : handleNext}
        >
          Next
          <ArrowRight height={13} style={{marginTop:"-2px"}}/>
        </span>
      </div>
    </div>
    </div>
  );
};

export default PaginationComponent;
